<template>
    <BaseWidget
        :id="id"
        :widget-name="'widget name'"
        :has-content="!!content"
        :is-loading="isLoading"
        :is-expanded="isExpanded"
        :widget-type="0"
        :widget-last-updated="null"
        v-on="$listeners"
    >
        <div class="widget-content">
            <div class="widget-inner">
                <div class="widget-configuration">{{ configuration }}</div>
                {{ content }}
            </div>
        </div>
    </BaseWidget>
</template>

<script type="text/babel">
import widgetInterface from './common/widgetInterface';
import BaseWidget from '../BaseWidget';

export default {
    components: { BaseWidget },

    props: widgetInterface,
};
</script>
